import { createFileRoute } from "@tanstack/react-router";
import { CustomersContainer } from "@/features/customers";

export const Route = createFileRoute("/$store/_layout/customers")({
	component: CustomersPage,
});

function CustomersPage() {
	return <CustomersContainer />;
}
